import { Box, HStack } from "@chakra-ui/react";
import { KeenSliderInstance } from "keen-slider/react"

interface Props {
  slider: KeenSliderInstance,
  currentSlide: number
}

const ImageSliderDots = ({ slider, currentSlide }: Props) => {
  const slidesCount = slider.track.details.slidesLength;

  return (
    <HStack
      justify="center"
      mt={2}
      position={"absolute"}
      left="50%"
      translateX={"-50%"}
      bottom={"10px"}
    >
      {Array.from({ length: slidesCount}).map((_, idx) => (
        <Box
          key={idx}
          w={2}
          h={2}
          transform={"translateY(-50%)"}
          borderRadius="full"
          bg={idx === currentSlide ? "#1F1F1F" : "#D9D9D9"}
          cursor="pointer"
          onClick={() => slider.moveToIdx(idx)}
        />
      ))}
    </HStack>
  );
}

export default ImageSliderDots;
